import React from 'react'
import { Alert } from '@mui/material'

const CouponCodeBanner = ({
	                          code,
							  pct,
	                          severity = "error",
	                          variant = "filled",
							  width = "fit-content",
	                          sx = {}
                          }) => {
	if (!code || !pct) {
		return null
	}

	return (
		<Alert
			severity={severity}
			variant={variant}
			sx={{
				width,
				...sx
			}}
		>
			Use Coupon Code <strong>{code}</strong> and
			get <strong>{pct}% off</strong> today!
		</Alert>
	)
}

export default CouponCodeBanner